import React from "react";
import { PaymentCancellationReminders, type PaymentCancellationReminderRequest } from "./PaymentCancellationReminders";
import { BankStatementBookingContext } from "./bankStatementBookingContext";

type ReminderRequest = { request: PaymentCancellationReminderRequest; onCreated: () => void };

/** Buchungen und ihre Mahnfolge bleiben auch beim Wechsel aus dem Kontoauszug erhalten. */
export function BankStatementBookingProvider({ children }: { children: React.ReactNode }) {
  const [reminders, setReminders] = React.useState<ReminderRequest[]>([]);
  const showReminders = React.useCallback((request: PaymentCancellationReminderRequest, onCreated: () => void) => {
    if (request.reminderCases.length > 0) setReminders(previous => [...previous, { request, onCreated }]);
  }, []);
  const value = React.useMemo(() => ({ showReminders }), [showReminders]);
  const current = reminders[0];
  return <BankStatementBookingContext.Provider value={value}>
    {children}
    <PaymentCancellationReminders pending={current?.request ?? null}
      onChange={request => setReminders(previous => request && previous[0]
        ? [{ ...previous[0], request }, ...previous.slice(1)] : previous.slice(1))}
      onCreated={() => current?.onCreated()} />
  </BankStatementBookingContext.Provider>;
}
